/**
 * 大屏布局编辑页（PlatenSetting）通过 provide 注入，子组件在拖拽编辑期间应禁止路由跳转与 window.open。
 */
export default {
  inject: {
    platenLayoutEditState: {
      from: 'platenLayoutEditState',
      default: null
    }
  },
  computed: {
    isPlatenLayoutEditing() {
      return !!(this.platenLayoutEditState && this.platenLayoutEditState.isEditing)
    }
  }
}
